import { mapActions } from 'vuex';
import loaderMixin from '@/mixins/loader';
import cmsContentMixin from '@/mixins/cmsContent';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import { formMixin } from '@/components/forms/mixin';

const TOTAL_COLUMNS = 12;
const COLUMN_OPTIONS = [
  { label: '0%', value: 0 },
  { label: '8.3%', value: 1 },
  { label: '16.6%', value: 2 },
  { label: '25%', value: 3 },
  { label: '33.3%', value: 4 },
  { label: '41.6%', value: 5 },
  { label: '50%', value: 6 },
  { label: '58.3%', value: 7 },
  { label: '66.6%', value: 8 },
  { label: '75%', value: 9 },
  { label: '83%', value: 10 },
  { label: '91.6%', value: 11 },
];
export default {
  mixins: [
    cmsContentMixin,
    formMixin,
    loaderMixin,
  ],
  props: {
    previewId: {},
  },
  data() {
    return {
      COLUMN_OPTIONS,
      columnChoice: {
        left: COLUMN_OPTIONS[0],
        middle: COLUMN_OPTIONS[7],
        right: COLUMN_OPTIONS[0],
      },
    };
  },
  components: {
    alertBox,
  },
  computed: {
    isColumnCountExceeding() {
      return (this.columnChoice.left.value + this.columnChoice.right.value) >= TOTAL_COLUMNS;
    },
    middleOption() {
      const sumColumns = this.columnChoice.left.value + this.columnChoice.right.value;
      return TOTAL_COLUMNS - sumColumns;
    },
    leftColumnClasses() {
      const option = this.columnChoice.left.value;
      return {
        column: true,
        [`small-${option}`]: !!option,
      };
    },
    middleColumnClasses() {
      return {
        column: true,
        [`small-${this.middleOption}`]: !!this.middleOption,
      };
    },
    rightColumnClasses() {
      const option = this.columnChoice.right.value;
      return {
        column: true,
        [option]: !!option,
      };
    },
  },
  mounted() {
    this.loaderAdd(document.body);
    this.getStaticPagePreview(this.previewId)
      .then((data) => {
        this.loaderRemove(document.body);
        this.installDynamicControls({ data });
      })
      .catch(() => this.loaderRemove(document.body));
  },
  methods: {
    ...mapActions('browse', ['getStaticPagePreview']),
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-static-preview/page-static-preview.js